/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} Coinvestments_Lp_Welcome_Heading1Inputs */

const en_coinvestments_lp_welcome_heading1 = /** @type {(inputs: Coinvestments_Lp_Welcome_Heading1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Welcome to ${i?.companyName}'s Co-Investments Portal`)
};

/**
* | output |
* | --- |
* | "Welcome to {companyName}'s Co-Investments Portal" |
*
* @param {Coinvestments_Lp_Welcome_Heading1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lp_welcome_heading1 = /** @type {((inputs: Coinvestments_Lp_Welcome_Heading1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lp_Welcome_Heading1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lp_welcome_heading1(inputs)
});
export { coinvestments_lp_welcome_heading1 as "coInvestments_lp_welcome_heading" }